
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/shows",
      function () {
        return require("private-next-pages/[locale]/shows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/shows"])
      });
    }
  